<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <div class="form-inline mb-3">
          <search-box v-model="search" placeholder="พิมพ์เพื่อค้นหา" />
          <div class="ml-auto">
            <b-button v-b-modal.add-faculty-modal variant="primary">
              <font-awesome-icon icon="plus-circle" />เพิ่มรายการคณะ
            </b-button>
          </div>
        </div>
        <faculty-list-table
          :content="faculties"
          :search-term="searchTerm"
          @delete="deleteFaculty"
        />

        <add-faculty-modal />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FacultyListTable from '@/components/settings/faculties/FacultyListTable'
import AddFacultyModal from '@/components/settings/faculties/AddFacultyModal'
import SearchBox from '@/components/shared/SearchBox'

export default {
  components: {
    FacultyListTable, AddFacultyModal, SearchBox
  },
  data () {
    return {
      searchTerm: null
    }
  },
  computed: {
    faculties () { return this.$store.state.faculty.all },
    search: {
      get () { return this.searchTerm },
      set (value) {
        this.searchTerm = value
      }
    }
  },
  methods: {
    async deleteFaculty (faculty) {
      if (!await this.$bvModal.msgBoxConfirm(
        `การลบคณะจะทำให้หน่วยงานในสังกัดถูกลบไปด้วย และไม่สามารถกู้คืนได้ ยืนยันการลบรายการ "${faculty.name}" หรือไม่?`,
        {
          title: 'ยืนยันการลบคณะ',
          okTitle: 'ลบ',
          cancelTitle: 'ยกเลิก',
          centered: true,
          okVariant: 'danger'
        }
      )) {
        return
      }

      try {
        await this.$store.dispatch('faculty/deleteFaculty', faculty.id)

        this.$bvToast.toast('ลบรายการคณะสำเร็จ', {
          title: 'แจ้งเตือน',
          variant: 'success',
          solid: true
        })
      } catch (_) {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>
